__webpack_require__.p = "https://gamma.reporting.agids.amazon.dev/";